export const MAX_BATTLE_TOPICS_TO_REVISIT = 3;

export interface BattleQuizTopicWrongRow {
	topicId: string;
	name: string;
	wrongCount: number;
}

/**
 * Picks up to {@link MAX_BATTLE_TOPICS_TO_REVISIT} topics with the most incorrect answers
 * (stable tie-break by `topicId`).
 */
export function takeTopTopicsToRevisit(
	rows: readonly BattleQuizTopicWrongRow[],
): Array<{ topicId: string; name: string }> {
	return [...rows]
		.sort((a, b) => {
			if (b.wrongCount !== a.wrongCount) {
				return b.wrongCount - a.wrongCount;
			}
			return a.topicId.localeCompare(b.topicId);
		})
		.slice(0, MAX_BATTLE_TOPICS_TO_REVISIT)
		.map(({ topicId, name }) => ({ topicId, name }));
}
